const getters = {
	/**
	 * Retorna as regras de estratificações criadas pelo usuário.
	 * @returns {array} - Uma lista de regras de estratificações.
	 */
	rules(state)
	{
		return state.rules;
	},
};

export default { getters };
